import * as Yup from 'yup'

const CPF_REGEX = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
const CNS_REGEX = /^\d{3}\s?\d{4}\s?\d{4}\s?\d{4}$/

// Etapa 1 valida apenas a identificação: o aceite do termo é a etapa 2 (ConsentimentoTeleConsulta).
export const loginSchema = Yup.object().shape({
  numeroDocumento: Yup.string()
    .required('O campo CPF/CNS é obrigatório')
    .test('cpf-cns-valido', 'CPF ou CNS inválido', (value) => {
      if (!value) return false
      const digits = value.replace(/\D/g, '')
      if (digits.length === 11) return CPF_REGEX.test(value)
      if (digits.length === 15) return CNS_REGEX.test(value)
      return false
    }),
})
